import { css, cssManager } from '@design.estate/dees-element';
import { echartsBaseStyles } from '../dees-chart-echarts-styles.js';

export const donutStyles = [
  ...echartsBaseStyles,
  css`
    :host {
      height: 360px;
    }
    .chartContainer {
      inset: 12px 0;
    }
  `,
];
